import { Directive, ElementRef, OnDestroy } from '@angular/core';
import { LangChangeEvent } from '@ngx-translate/core';
import { LanguageService } from 'src/app/core/language/services/language.service';
import { BusinessTypeService } from 'src/app/core/services/business-type.service';
import { environment } from '@app/env';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appHomeLink]',
})
export class HomeLinkDirective implements OnDestroy {
  private notifier = new Subject<void>();
  private isB2BType: boolean;

  constructor(
    private el: ElementRef,
    private businessTypeService: BusinessTypeService,
    private languageService: LanguageService
  ) {
    this.languageService.translate.onLangChange
      .pipe(takeUntil(this.notifier))
      .subscribe((langChangeEvent: LangChangeEvent) => {
        this.updateHomeLink(langChangeEvent.lang);
      });

    this.businessTypeService.isB2BType$.pipe(takeUntil(this.notifier)).subscribe((isB2BType: boolean) => {
      this.isB2BType = isB2BType;
      this.updateHomeLink(languageService.translate.currentLang);
    });
  }

  ngOnDestroy(): void {
    this.notifier.next();
    this.notifier.complete();
  }

  private updateHomeLink(lang: string): void {
    let homeLink = '';
    if (lang === this.languageService.defaultLanguage) {
      homeLink = this.isB2BType ? environment.homePageB2BFr : environment.homePageB2CFr;
    } else {
      homeLink = this.isB2BType ? environment.homePageB2BNl : environment.homePageB2CNl;
    }
    this.el.nativeElement.setAttribute('href', environment.websiteUrl + '/' + lang + homeLink);
  }
}
